import React, {Component} from 'react';
import {Col, Row} from "reactstrap";

class AutoBankingComponent extends Component {

    changeForm = (event) => {
        let autoBaking = this.props.autoBaking;
        let name = event.target.name;
        autoBaking[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        console.log(autoBaking)
        this.props.onChangeAutoBanking( this.props.actionKey, autoBaking );
    }

    render() {
        return (
            <>
                {
                    this.props.autoBaking.typeAction === 'create' ? (
                        <>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label>Loại Auto Banking</label>
                                </Col>
                                <Col md={10}>
                                    <div className="form-check form-check-inline">
                                        <label className="form-check-label">
                                            <input type="radio" className="form-check-input" name="type_bank"
                                                   value={ this.props.autoBaking.type_bank }
                                                   onChange={ this.changeForm } checked={true}
                                            /> Bên thứ 3
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="type">Loại thanh toán</label>
                                </Col>
                                <Col md={10}>
                                    <select className="form-control" name="type" id="type" defaultValue={""} onChange={ this.changeForm }>
                                        <option value="" disabled={true}>Chọn loại thanh toán</option>
                                        {
                                            this.props.listConfigPayment.map( (bank, key) => {
                                                return (
                                                    <option value={bank.code} key={key}>{ bank.name }</option>
                                                )
                                            })
                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="url">URL</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="url" placeholder="URL" id="url" onChange={ this.changeForm } />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="account">Tài khoản</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="account" placeholder="Tài khoản" id="account" onChange={ this.changeForm } />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="password">Mật khẩu</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="password" placeholder="Mật khẩu" id="password" onChange={ this.changeForm } />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="token">Token</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="token" placeholder="Token" id="token" onChange={ this.changeForm } />
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label>Loại Auto Banking</label>
                                </Col>
                                <Col md={10}>
                                    <div className="form-check form-check-inline">
                                        <label className="form-check-label">
                                            <input type="radio" className="form-check-input"
                                                   value={ this.props.autoBaking.type_bank }
                                                   onChange={ this.changeForm } checked={true}
                                            /> Bên thứ 3
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="type">Loại thanh toán</label>
                                </Col>
                                <Col md={10}>
                                    <select className="form-control" name="type" id="type"
                                            defaultValue={this.props.autoBaking.type} onChange={ this.changeForm }
                                    >
                                        <option value="" disabled={true}>Chọn loại thanh toán</option>
                                        {
                                            this.props.listConfigPayment.map( (bank, key) => {
                                                return (
                                                    <option value={bank.code} key={key}>{ bank.name }</option>
                                                )
                                            })
                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="url">URL</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="url" placeholder="URL"
                                           id="url" onChange={ this.changeForm }
                                           defaultValue={ this.props.autoBaking.setupkey }
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="account">Tài khoản</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="account" placeholder="Tài khoản"
                                           id="account" onChange={ this.changeForm }
                                           defaultValue={ this.props.autoBaking.account }
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="password">Mật khẩu</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="password" placeholder="Mật khẩu"
                                           id="password" onChange={ this.changeForm }
                                           defaultValue={ this.props.autoBaking.password }
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col md={2} className="col-form-label">
                                    <label htmlFor="token">Token</label>
                                </Col>
                                <Col md={10}>
                                    <input className="form-control" type="text" name="token" placeholder="Token"
                                           id="token" onChange={ this.changeForm }
                                           defaultValue={ this.props.autoBaking.token }
                                    />
                                </Col>
                            </Row>
                        </>
                    )
                }
            </>
        );
    }
}

export default AutoBankingComponent;